import { Timestamp } from '@angular/fire/firestore';

export interface OtaJob {
  versionFile: string;
  assetCount?: number;
  errorCount?: number;
  macs?: string[];
  queryLimit?: number;
  query: OtaJobQuery;
  startedOn: Timestamp;
  startedBy: string;
  failureReason?: string;
}

export interface OtaJobQuery {
  otaJobId?: string;
  earliestVersion?: string;
  latestVersion?: string;
  hardware?: string;
  organizationId?: string;
  locationId?: string;
  isOnline?: boolean;
}
